import {
  FloatingFocusManager,
  FloatingOverlay,
  FloatingPortal,
  useDismiss,
  useFloating,
  useInteractions,
  useRole,
} from "@floating-ui/react";
import { HTMLProps, PropsWithChildren, ReactNode } from "react";
import "./Modal.css";

interface ModalProps {
  isOpen?: boolean;
  title?: string;
  wrapperClassName?: string;
  footerChildren?: ReactNode;
}

function Modal(
  props: PropsWithChildren<ModalProps> & HTMLProps<HTMLDivElement>
) {
  const {
    children,
    footerChildren,
    isOpen = true,
    title,
    className,
    wrapperClassName,
    ...otherProps
  } = props;

  const { refs, context } = useFloating({ open: isOpen });

  const dismiss = useDismiss(context, { bubbles: true });
  const role = useRole(context);

  const { getFloatingProps } = useInteractions([dismiss, role]);

  if (!isOpen) return null;

  return (
    <FloatingPortal root={document.getElementById("game-root")}>
      <FloatingOverlay className={`modal-wrapper ${wrapperClassName ?? ""}`}>
        <FloatingFocusManager context={context}>
          <div
            className={`modal ${className}`}
            ref={refs.setFloating}
            {...getFloatingProps(otherProps)}
          >
            {title !== undefined ? (
              <div className="modal-header">
                <h2>{title}</h2>
              </div>
            ) : null}
            <div className="modal-body">{children}</div>
            {footerChildren === undefined ? null : (
              <div className="modal-footer">{footerChildren}</div>
            )}
          </div>
        </FloatingFocusManager>
      </FloatingOverlay>
    </FloatingPortal>
  );
}

export default Modal;
